// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import yoga from "../assets/yoga4.jpg";
// import axios from "axios";
// import { BASE_URL } from "../Config";

// // POPUPS
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";

// function Login({ setUser }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   const navigate = useNavigate();

//   // Detect mobile device
//   useEffect(() => {
//     const onResize = () => setScreenWidth(window.innerWidth);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const isMobile = screenWidth < 768;

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post(`${BASE_URL}/auth/login`, {
//         email,
//         password,
//       });

//       const token = res.data.token;
//       const loggedUser = res.data.data;

//       if (!token) {
//         setErrorMessage("Invalid login response. Try again!");
//         setErrorPopup(true);
//         return;
//       }

//       localStorage.setItem("token", token);
//       localStorage.setItem("user", JSON.stringify(loggedUser));
//       setUser(loggedUser);

//       setSuccessPopup(true);

//       setTimeout(() => {
//         setSuccessPopup(false);
//         if (loggedUser.role === "admin") {
//           navigate("/dashboard");
//         } else {
//           navigate("/user-rules");
//         }
//       }, 1200);
//     } catch (err) {
//       console.log("LOGIN ERROR:", err);

//       const msg =
//         err.response?.data?.message ||
//         "Login failed! Please check your credentials.";
//       setErrorMessage(msg);
//       setErrorPopup(true);
//     }
//   };

//   return (
//     <motion.div
//       style={{
//         ...styles.page,
//         paddingTop: isMobile ? "80px" : "120px",
//         padding: isMobile ? "80px 10px 20px" : "120px 20px 20px",
//       }}
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//     >
//       <motion.div
//         style={{
//           ...styles.card,
//           width: isMobile ? "100%" : "900px",
//           maxWidth: "900px",
//           height: isMobile ? "auto" : "480px",
//           flexDirection: isMobile ? "column" : "row",
//         }}
//         initial={{ y: 50, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 80, damping: 15 }}
//       >
//         {/* ✔ LEFT IMAGE */}
//         <motion.div
//           style={{
//             ...styles.left,
//             width: isMobile ? "100%" : "50%",
//             borderRight: isMobile ? "none" : "1px solid #f0f0f0",
//           }}
//         >
//           <motion.img
//             src={yoga}
//             alt="yoga"
//             style={{
//               ...styles.img,
//               width: isMobile ? "100%" : "80%",
//             }}
//             whileHover={{ scale: 1.05 }}
//           />
//         </motion.div>

//         {/* ✔ RIGHT FORM */}
//         <motion.div
//           style={{
//             ...styles.right,
//             width: isMobile ? "100%" : "50%",
//             padding: isMobile ? "25px" : "50px",
//           }}
//         >
//           <h2 style={styles.title}>Yoga Login</h2>
//           <p style={styles.subtitle}>Make sure your account is secure</p>

//           <form onSubmit={handleLogin} style={styles.form}>
//             <input
//               type="email"
//               placeholder="Type your Email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//               required
//             />

//             <input
//               type="password"
//               placeholder="Type your Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//               required
//             />

//             <div style={styles.linkRow}>
//               <Link to="/forgot-password" style={styles.link}>
//                 Forgot Password?
//               </Link>
//               <Link to="/register" style={styles.link}>
//                 Register
//               </Link>
//             </div>

//             <motion.button
//               type="submit"
//               style={styles.button}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               LOGIN
//             </motion.button>
//           </form>
//         </motion.div>
//       </motion.div>

//       {/* ✔ SUCCESS POPUP */}
//       <SuccessPopup
//         open={successPopup}
//         onClose={() => setSuccessPopup(false)}
//         message="Login Successful!"
//       />

//       <ErrorPopup
//         open={errorPopup}
//         onClose={() => setErrorPopup(false)}
//         message={errorMessage}
//       />
//     </motion.div>
//   );
// }

// const styles = {
//   page: {
//     backgroundColor: "#62bf6bff",
//     minHeight: "100vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "flex-start",
//   },
//   card: {
//     backgroundColor: "#fff",
//     borderRadius: "15px",
//     display: "flex",
//     boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
//     overflow: "hidden",
//   },
//   left: { display: "flex", justifyContent: "center", alignItems: "center" },
//   img: { height: "auto" },
//   right: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//   },
//   title: { fontSize: "24px", fontWeight: "600", color: "#333" },
//   subtitle: { fontSize: "14px", color: "#777", marginBottom: "25px" },
//   form: {
//     width: "100%",
//     display: "flex",
//     flexDirection: "column",
//     gap: "15px",
//   },
//   input: {
//     padding: "12px",
//     border: "1px solid #ccc",
//     borderRadius: "6px",
//     fontSize: "15px",
//   },
//   linkRow: { display: "flex", justifyContent: "space-between" },
//   link: { textDecoration: "none", color: "#333", fontWeight: "500" },
//   button: {
//     backgroundColor: "#62bf6bff",
//     borderRadius: "30px",
//     padding: "12px",
//     border: "none",
//     fontWeight: "bold",
//     fontSize: "16px",
//     cursor: "pointer",
//   },
// };

// export default Login;

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import yoga from "../assets/yoga4.jpg";
// import axios from "axios";
// import { BASE_URL } from "../Config";

// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";

// function Login({ setUser }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   const navigate = useNavigate();

//   useEffect(() => {
//     const onResize = () => setScreenWidth(window.innerWidth);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const isMobile = screenWidth < 768;

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post(`${BASE_URL}/auth/login`, { email, password });

//       const token = res.data.token;
//       const loggedUser = res.data.data;

//       if (!token) {
//         setErrorMessage("Invalid login response. Try again!");
//         setErrorPopup(true);
//         return;
//       }

//       // ✅ sessionStorage: clears automatically when tab/browser is closed
//       sessionStorage.setItem("token", token);
//       sessionStorage.setItem("user", JSON.stringify(loggedUser));

//       // ✅ Also keep localStorage in sync for any existing code that reads it
//       // localStorage.setItem("token", token);
//       // localStorage.setItem("user", JSON.stringify(loggedUser));

//       setUser(loggedUser);
//       setSuccessPopup(true);

//       setTimeout(() => {
//         setSuccessPopup(false);
//         if (loggedUser.role === "admin") {
//           navigate("/dashboard");
//         } else {
//           navigate("/user-rules");
//         }
//       }, 1200);
//     } catch (err) {
//       const msg =
//         err.response?.data?.message || "Login failed! Please check your credentials.";
//       setErrorMessage(msg);
//       setErrorPopup(true);
//     }
//   };

//   return (
//     <motion.div
//       style={{
//         ...styles.page,
//         paddingTop: isMobile ? "80px" : "120px",
//         padding: isMobile ? "80px 10px 20px" : "120px 20px 20px",
//       }}
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//     >
//       <motion.div
//         style={{
//           ...styles.card,
//           width: isMobile ? "100%" : "900px",
//           maxWidth: "900px",
//           height: isMobile ? "auto" : "480px",
//           flexDirection: isMobile ? "column" : "row",
//         }}
//         initial={{ y: 50, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 80, damping: 15 }}
//       >
//         {/* LEFT IMAGE */}
//         <motion.div
//           style={{
//             ...styles.left,
//             width: isMobile ? "100%" : "50%",
//             borderRight: isMobile ? "none" : "1px solid #f0f0f0",
//           }}
//         >
//           <motion.img
//             src={yoga}
//             alt="yoga"
//             style={{ ...styles.img, width: isMobile ? "100%" : "80%" }}
//             whileHover={{ scale: 1.05 }}
//           />
//         </motion.div>

//         {/* RIGHT FORM */}
//         <motion.div
//           style={{
//             ...styles.right,
//             width: isMobile ? "100%" : "50%",
//             padding: isMobile ? "25px" : "50px",
//           }}
//         >
//           <h2 style={styles.title}>Yoga Login</h2>
//           <p style={styles.subtitle}>Make sure your account is secure</p>

//           <form onSubmit={handleLogin} style={styles.form}>
//             <input
//               type="email"
//               placeholder="Type your Email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//               required
//             />
//             <input
//               type="password"
//               placeholder="Type your Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//               required
//             />
//             <div style={styles.linkRow}>
//               <Link to="/forgot-password" style={styles.link}>Forgot Password?</Link>
//               <Link to="/register" style={styles.link}>Register</Link>
//             </div>
//             <motion.button
//               type="submit"
//               style={styles.button}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               LOGIN
//             </motion.button>
//           </form>
//         </motion.div>
//       </motion.div>

//       <SuccessPopup open={successPopup} onClose={() => setSuccessPopup(false)} message="Login Successful!" />
//       <ErrorPopup open={errorPopup} onClose={() => setErrorPopup(false)} message={errorMessage} />
//     </motion.div>
//   );
// }

// const styles = {
//   page: {
//     backgroundColor: "#62bf6bff",
//     minHeight: "100vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "flex-start",
//   },
//   card: {
//     backgroundColor: "#fff",
//     borderRadius: "15px",
//     display: "flex",
//     boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
//     overflow: "hidden",
//   },
//   left: { display: "flex", justifyContent: "center", alignItems: "center" },
//   img: { height: "auto" },
//   right: { display: "flex", flexDirection: "column", alignItems: "center" },
//   title: { fontSize: "24px", fontWeight: "600", color: "#333" },
//   subtitle: { fontSize: "14px", color: "#777", marginBottom: "25px" },
//   form: { width: "100%", display: "flex", flexDirection: "column", gap: "15px" },
//   input: { padding: "12px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "15px" },
//   linkRow: { display: "flex", justifyContent: "space-between" },
//   link: { textDecoration: "none", color: "#333", fontWeight: "500" },
//   button: {
//     backgroundColor: "#62bf6bff",
//     borderRadius: "30px",
//     padding: "12px",
//     border: "none",
//     fontWeight: "bold",
//     fontSize: "16px",
//     cursor: "pointer",
//   },
// };

// export default Login;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import yoga from "../assets/yoga4.jpg";
import axios from "axios";
import { BASE_URL } from "../Config";

import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";

function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const onResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = screenWidth < 768;

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${BASE_URL}/auth/login`, { email, password });

      const token = res.data.token;
      const loggedUser = res.data.data;

      if (!token) {
        setErrorMessage("Invalid login response. Try again!");
        setErrorPopup(true);
        return;
      }

      // ✅ FIXED: Only sessionStorage — clears automatically on tab/browser close
      // ❌ REMOVED: localStorage — was causing user to stay logged in after logout + refresh
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("user", JSON.stringify(loggedUser));

      setUser(loggedUser);
      setSuccessPopup(true);

      setTimeout(() => {
        setSuccessPopup(false);
        if (loggedUser.role === "admin") {
          navigate("/dashboard");
        } else {
          navigate("/user-rules");
        }
      }, 1200);
    } catch (err) {
      const msg =
        err.response?.data?.message || "Login failed! Please check your credentials.";
      setErrorMessage(msg);
      setErrorPopup(true);
    }
  };

  return (
    <motion.div
      style={{
        ...styles.page,
        paddingTop: isMobile ? "80px" : "120px",
        padding: isMobile ? "80px 10px 20px" : "120px 20px 20px",
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        style={{
          ...styles.card,
          width: isMobile ? "100%" : "900px",
          maxWidth: "900px",
          height: isMobile ? "auto" : "480px",
          flexDirection: isMobile ? "column" : "row",
        }}
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 80, damping: 15 }}
      >
        {/* LEFT IMAGE */}
        <motion.div
          style={{
            ...styles.left,
            width: isMobile ? "100%" : "50%",
            borderRight: isMobile ? "none" : "1px solid #f0f0f0",
          }}
        >
          <motion.img
            src={yoga}
            alt="yoga"
            style={{ ...styles.img, width: isMobile ? "100%" : "80%" }}
            whileHover={{ scale: 1.05 }}
          />
        </motion.div>

        {/* RIGHT FORM */}
        <motion.div
          style={{
            ...styles.right,
            width: isMobile ? "100%" : "50%",
            padding: isMobile ? "25px" : "50px",
          }}
        >
          <h2 style={styles.title}>Yoga Login</h2>
          <p style={styles.subtitle}>Make sure your account is secure</p>

          <form onSubmit={handleLogin} style={styles.form}>
            <input
              type="email"
              placeholder="Type your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
            <input
              type="password"
              placeholder="Type your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              required
            />
            <div style={styles.linkRow}>
              <Link to="/forgot-password" style={styles.link}>Forgot Password?</Link>
              <Link to="/register" style={styles.link}>Register</Link>
            </div>
            <motion.button
              type="submit"
              style={styles.button}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              LOGIN
            </motion.button>
          </form>
        </motion.div>
      </motion.div>

      <SuccessPopup open={successPopup} onClose={() => setSuccessPopup(false)} message="Login Successful!" />
      <ErrorPopup open={errorPopup} onClose={() => setErrorPopup(false)} message={errorMessage} />
    </motion.div>
  );
}

const styles = {
  page: {
    backgroundColor: "#62bf6bff",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "15px",
    display: "flex",
    boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
    overflow: "hidden",
  },
  left: { display: "flex", justifyContent: "center", alignItems: "center" },
  img: { height: "auto" },
  right: { display: "flex", flexDirection: "column", alignItems: "center" },
  title: { fontSize: "24px", fontWeight: "600", color: "#333" },
  subtitle: { fontSize: "14px", color: "#777", marginBottom: "25px" },
  form: { width: "100%", display: "flex", flexDirection: "column", gap: "15px" },
  input: { padding: "12px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "15px" },
  linkRow: { display: "flex", justifyContent: "space-between" },
  link: { textDecoration: "none", color: "#333", fontWeight: "500" },
  button: {
    backgroundColor: "#62bf6bff",
    borderRadius: "30px",
    padding: "12px",
    border: "none",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default Login;